<template>
  <v-container>
    <v-card
      outlined
      class="pa-3 mb-3"
    >
      <v-row dense>
        <v-col
          cols="6"
          md="3"
        >
          <v-text-field
            v-model="dateFrom"
            type="date"
            outlined
            dense
            hide-details
            label="ລຶບແຕ່ວັນທີ"
          />
        </v-col>
        <v-col
          cols="6"
          md="3"
        >
          <v-text-field
            v-model="dateTo"
            type="date"
            outlined
            dense
            hide-details
            label="ຫາວັນທີ"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="filter"
            outlined
            dense
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
            label="ຊື່ບໍລິສັດ, ເບີໂທ, ເລກບິນ"
            @keyup.enter="load"
            @click:clear="clearFilter"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="d-flex align-center"
        >
          <!-- Dates and the search text apply only when this is pressed. -->
          <v-btn
            color="primary"
            depressed
            class="mr-2"
            :loading="loading"
            @click="load"
          >
            <v-icon left>
              mdi-magnify
            </v-icon>
            ຄົ້ນຫາ
          </v-btn>
          <v-btn
            color="success"
            depressed
            :loading="exporting"
            @click="exportExcel"
          >
            <v-icon left>
              mdi-microsoft-excel
            </v-icon>
            Export Excel
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <div class="mb-2 text-body-2">
      ລຶບແລ້ວ {{ rows.length }} ໃບ · ລວມ {{ money(sum) }} ກີບ
    </div>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="rows"
        :loading="loading"
        :items-per-page="50"
        no-data-text="ບໍ່ມີບິນທີ່ລຶບໃນຊ່ວງນີ້"
      >
        <template v-slot:[`item.company_name`]="{ item }">
          <div>{{ item.company_name }}</div>
          <div class="text-caption grey--text">
            {{ item.customer_code }} · {{ item.phone }}
          </div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          {{ money(item.total) }}
        </template>
        <template v-slot:[`item.reason`]="{ item }">
          <div style="min-width: 180px">
            {{ item.reason }}
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { today } from '@/Helpers/localDate';

export default {
  name: 'BillDeleteHistory',
  title() {
    return 'Vientiane Waste Co-Dev|Bill Delete History';
  },
  data() {
    return {
      // Opens on today, like the other history pages.
      dateFrom: today(),
      dateTo: today(),
      filter: '',
      applied: {},
      rows: [],
      loading: false,
      exporting: false,
      headers: [
        { text: 'ລຳດັບ', value: 'no' },
        { text: 'ວັນທີລຶບ', value: 'deleted_at' },
        { text: 'ເລກບິນ', value: 'bill_number' },
        { text: 'ລູກຄ້າ', value: 'company_name' },
        { text: 'ລາຍການ', value: 'content' },
        { text: 'ເດືອນບິນ', value: 'bill_month' },
        { text: 'ຍອດເງິນ', value: 'total', align: 'end' },
        { text: 'ສະຖານະກ່ອນລຶບ', value: 'bill_status' },
        { text: 'ເຫດຜົນ', value: 'reason', sortable: false },
        { text: 'ຜູ້ສົ່ງ', value: 'submitter' },
        { text: 'ຜູ້ອະນຸມັດ', value: 'reviewer' },
        { text: 'ເລກຄຳຂໍ', value: 'request_id' },
      ],
    };
  },
  computed: {
    sum() {
      return this.rows.reduce((total, row) => total + Number(row.total || 0), 0);
    },
  },
  created() {
    this.load();
  },
  methods: {
    money(value) {
      return Number(value || 0).toLocaleString();
    },
    params() {
      return {
        date_from: this.dateFrom || undefined,
        date_to: this.dateTo || undefined,
        filter: this.filter || undefined,
      };
    },
    clearFilter() {
      this.filter = '';
      this.load();
    },
    load() {
      this.loading = true;
      // The export follows what the table shows, not dates changed since the last search.
      this.applied = this.params();
      this.$axios
        .get('bill-delete-request/history', { params: this.applied })
        .then((res) => {
          this.rows = res.data.data.data || [];
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.loading = false;
        });
    },
    exportExcel() {
      this.exporting = true;
      this.$axios
        .get('bill-delete-request/history/export', { params: this.applied, responseType: 'blob' })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = `ປະຫວັດການລຶບບິນ_${this.applied.date_from || 'all'}_${this.applied.date_to || 'all'}.xlsx`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => this.toast('error', 'Export ບໍ່ສຳເລັດ'))
        .finally(() => {
          this.exporting = false;
        });
    },
    message(error) {
      return (error.response && error.response.data && error.response.data.message) || 'Something went wrong';
    },
    toast(color, msg) {
      this.$store.commit('Toast_State', { value: true, color, msg });
    },
  },
};
</script>
